class IamaranthHero extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-iamaranth-hero-slide]')];
    this.controls = [...this.querySelectorAll('[data-iamaranth-hero-control]')];
    this.previous = this.querySelector('[data-iamaranth-hero-prev]');
    this.next = this.querySelector('[data-iamaranth-hero-next]');
    this.activeIndex = 0;
    if (this.slides.length < 2) return;
    this.controls.forEach((control, index) => control.addEventListener('click', () => this.show(index)));
    this.previous?.addEventListener('click', () => this.show((this.activeIndex - 1 + this.slides.length) % this.slides.length));
    this.next?.addEventListener('click', () => this.show((this.activeIndex + 1) % this.slides.length));
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.timer = window.setInterval(() => this.show((this.activeIndex + 1) % this.slides.length), 8000);
      this.addEventListener('mouseenter', () => window.clearInterval(this.timer));
      this.addEventListener('mouseleave', () => {
        this.timer = window.setInterval(() => this.show((this.activeIndex + 1) % this.slides.length), 8000);
      });
    }
  }

  disconnectedCallback() { if (this.timer) window.clearInterval(this.timer); }

  show(index) {
    this.activeIndex = index;
    this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    this.controls.forEach((control, i) => {
      const active = i === index;
      control.classList.toggle('is-active', active);
      control.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }
}

if (!customElements.get('iamaranth-hero')) customElements.define('iamaranth-hero', IamaranthHero);
